/*
 * @Author: your name
 * @Date: 2021-03-02 13:42:55
 * @LastEditTime: 2021-05-18 15:41:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \莅视pc端\SurgicalCommunication\src\store\index.js
 */
/**
 * Created by Lee on 2019/1/8.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import persistedState from 'vuex-persistedstate'
import article from './modules/article'
import test from './modules/test'

Vue.use(Vuex);

export default new Vuex.Store({
    modules:{
        article,
        test
    },
    state:{
        team:{},
        info:{},
    },
    mutations: {
        //es6语法，等同edit:funcion(){...}
        edit(state,payload) {
            state.team = payload.payload
        },
        changeInfo(state,payload){
            state.info = payload.payload
        }
    },

    plugins: [persistedState()]
})